export default __webpack_public_path__ + "static/media/1757.fd032dd6.png";